export default __webpack_public_path__ + "static/media/28.ee951d24.jpeg";